import { render, staticRenderFns } from "./CurrentProcess.vue?vue&type=template&id=7f13cc26&scoped=true"
import script from "./CurrentProcess.vue?vue&type=script&lang=ts"
export * from "./CurrentProcess.vue?vue&type=script&lang=ts"
import style0 from "./CurrentProcess.vue?vue&type=style&index=0&id=7f13cc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f13cc26",
  null
  
)

export default component.exports